var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"absolute mt-2 left-1/2 top-2/3 -translate-y-1/2 rounded bg-inherit px-2 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100 transition-all ease-in duration-200 hidden group-hover:block"},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }